import addHeaderToRequestOptions from "../../utils/add-header-to-request-options";
import identity, { clearCache } from "../identity";
import E from "../../utils/encrypt";

function buildRequestToken(key, remoteId, time) {
  if (!remoteId) {
    throw new Error("buildRequestToken: Missing remoteId");
  }
  if (isNaN(time)) {
    throw new Error("buildRequestToken: time is NaN");
  }
  var receiptId = Math.floor(Math.random() * 0xffffffff);
  var random = Math.floor(Math.random() * 32767) + 1;
  var product = random * 63997;
  var nonce = product ^ 0x6e092218;
  var token = receiptId + "|" + nonce + "|" + remoteId + "|" + time;
  return E.encrypt(token, key);
}

export const headerName = "Request-Token";
const fixedKey = "fbf22f0954134426815b719b9b4f6062";

const requestToken = async () => {
  const { timeDifference, remoteId } = await identity();
  const time = Math.floor(Date.now() / 1000 + timeDifference);
  // Build a new token for each request.
  return buildRequestToken(fixedKey, remoteId, time);
};

const requestTokenHeader = fetch => {
  return async (url, opts = {}) => {
    return fetch(
      url,
      addHeaderToRequestOptions(opts, {
        [headerName]: await requestToken()
      })
    ).then(async resp => {
      const { status } = resp;
      if (status === 401) {
        // Remove identity information since a 401 could of happened because
        // user changed ip addresses.
        clearCache();
      }
      return resp;
    });
  };
};

export default requestTokenHeader;
